import { Option, TeamMemberWithOrganizationTeamMembers } from "~/common/utils";
import { OWNER_OPTIONS } from "../constants";

export const generateTeamMemberOptions = (
  staffList?: TeamMemberWithOrganizationTeamMembers[],
): Option[] => [
  {
    label: "Unassigned",
    value: OWNER_OPTIONS.unassigned,
  },
  ...(staffList?.map(({ name, last_name, organization_team_members }) => ({
    label: `${name} ${last_name}`,
    value: organization_team_members[0].id,
  })) ?? []),
];
